export default __webpack_public_path__ + "static/media/apply_05_active.4a036a4c.png";